import { NgbDateAdapter, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { Injectable } from "@angular/core";

@Injectable()
export class AppDateAdapter extends NgbDateAdapter<number> {
  fromModel(value: number) {
    if (value == null || value == 0) {
      return null;
    }

    const date = new Date(value);
    return {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate(),
    };
  }

  toModel(date: NgbDateStruct) {
    if (date == null) {
      return 0;
    }

    return Date.UTC(date.year, date.month - 1, date.day);
  }
}
